import Base from './index.vue'
import Account from './Account.vue'
import APIKeys from './APIKeys.vue'
import Workspace from './Workspace.vue'
import Team from './Team.vue'
import Billing from './Billing.vue'
import ComingSoon from '@/pages/ComingSoon.vue'

const routes = [
  {
    name: 'Settings',
    path: 'settings',
    meta: { title: 'Settings' },
    component: Base,
    redirect: { name: 'AccountSettings' },
    children: [
      {
        name: 'AccountSettings',
        path: 'account',
        component: Account,
        meta: { title: 'Account Settings' },
      },
      {
        name: 'APIKeys',
        path: 'apikeys',
        component: APIKeys,
        meta: { title: 'API keys' },
      },
      {
        name: 'TeamSettings',
        path: 'team',
        component: Team,
        meta: { title: 'Team Settings' },
      },
      {
        name: 'BillingSettings',
        path: 'billing',
        component: Billing,
        meta: { title: 'Billing Settings' },
      },
      {
        name: 'WorkspaceSettings',
        path: 'workspace',
        component: Workspace,
        meta: { title: 'Workspace Settings' },
      },
      {
        name: 'CRMSettings',
        path: 'crm',
        component: ComingSoon,
        meta: { title: 'CRM Settings' },
      },
      {
        name: 'TaskSettings',
        path: 'tasks',
        component: ComingSoon,
        meta: { title: 'Tasks Settings' },
      },
    ],
  },
]

export default routes
